import { actionsTypes } from '../../types';

const defaultState = {
  activeCard: null
};

const map = {
  [actionsTypes.SET_ACTIVE_CARD]: (state, action) => ({
    ...state,
    activeCard: action.payload.data
  })
};

export default (state = defaultState, action) =>
  (map[action.type] && map[action.type](state, action)) || state;
